import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=7be996d3&scoped=true"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=7be996d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be996d3",
  null
  
)

export default component.exports